import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-background border-t border-white/5 text-center" role="contentinfo" data-id="element-95">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-96">
        <div className="mb-8" data-id="element-97">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-98">
            🛡️ ADULTO DE RESCATE™
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-99">
            El sistema de acompañamiento N°1 para padres de adolescentes de
            Argentina y LATAM.
          </p>
          <p className="text-gray-400" data-id="element-100">
            Porque amar a tu hijo/a no debería costarte todas las noches del
            año.
          </p>
        </div>

        <nav aria-label="Contacto y redes sociales" className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-12" data-id="element-101">
          <a href="mailto:soporteofiacialfegion@gmail.com" className="hover:text-gold transition-colors" data-id="element-102">
            📧 soporteofiacialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-103">
            |
          </span>
          <a href="https://www.instagram.com/fegion" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-104">
            📲 @fegion
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-105">
            |
          </span>
          <a href="https://www.fegion.shop" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-106">
            🌐 www.fegion.shop
          </a>
        </nav>

        <div className="border-t border-white/5 pt-8" data-id="element-107">
          <p className="text-gray-500 text-sm mb-6" data-id="element-108">
            © Adulto de Rescate 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-109">
            <p data-id="element-110">🛡️ "La adolescencia no espera. Pero tampoco es tarde."</p>
          </div>
        </div>
      </div>
    </footer>;
}